<template>
<div>

<div class="servicios">


       <div class="container pt-5">
           <h1 class="verde-espais text-center">{{somos.titulo}}</h1>
           <div class="somos">
               <div v-html="somos.contenido">
               </div>
               <p class="font-weight-bold  verde-espais">{{somos.firma}}</p>
           </div>

            <h1 class="titulo-servicios mt-5 marron-espais">Servicios</h1>

           <div class="row" v-for="(servicio,i) in servicios" :key="i">
                <div class="col-12">
                    <h2 class="pl-2 mt-4 verde-espais">{{servicio.titulo_servicio}}</h2>
                </div>
                <div class="col-sm-6" v-html="servicio.descripcion_servicios">

                </div>
                <div class="col-sm-6">
                   <img :src="`https://espais.com.py${servicio.imagen_servicio.data.url}`" class="img-fluid foto-servicio" alt="Arquitectura C">
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-12">
                    <h2 class="pl-2 mt-4 verde-espais">De Arquitectura en general</h2>
                </div>
                <div class="col-sm-6">
                       <ul>
                            <li>Consultoría: inversión en inmuebles, construcción, reformas, arreglos, presupuestos</li>
                            <li>Preparación de planos Municipales: para aprobación o regularización de construcciones privadas o comerciales. Habilitacion de patente comercial</li>
                            <li>Anteproyectos</li>
                            <li>Proyectos</li>
                            <li>Presupuestos de servicios de arquitectura y de construcciones</li>
                            <li>Legajos de obra: Proyectos Ejecutivos de Obra</li>
                            <li>Dirección de obras</li>
                            <li>Administración de obras</li>
                            <li>Fiscalización de obras</li>
                        </ul>
                </div>
                <div class="col-sm-6">
                   <img :src="require('@/assets/img/servicios/arquitectura_general.jpg')" class="img-fluid foto-servicio" alt="Arquitectura C">
                </div>
            </div> -->



             <!-- <div class="row">
                 <div class="col-12"><h2 class="pl-2 mt-4 verde-espais">Espacios Comerciales</h2></div>
                 <div class="col-sm-6">
                       <ul>
                            <li>Evaluación de espacios: diagnóstico de la situación.</li>
                            <li>FODA de empresa</li>
                            <li>Concepto de negocio</li>
                            <li>Briefing de Marca</li>
                            <li>Elaboración de un plan estratégico de marketing desde el punto de vista del interiorista.</li>
                        </ul>
                 </div>
                 <div class="col-sm-6">
                        <img :src="require('@/assets/img/servicios/espaciocomercial.jpg')" class="img-fluid foto-servicio" alt="">
                 </div>
             </div> -->


             <!-- <div class="row">
                 <div class="col-12">
                      <h2 class="verde-espais">Visual Merchandising</h2>
                 </div>
                 <div class="col-md-6">
                        <ul>
                            <li>Evaluación de espacios</li>
                            <li>FODA de empresa</li>
                            <li>Concepto de negocio</li>
                            <li>Declaración de Valores, Misión, Visión</li>
                            <li>Briefing de marca</li>
                            <li>Elaboración de un plan estratégico de marketing desde el punto de vista del interiorista y del visual merchandiser</li>
                            <li>Plan de acciones de visual merchandising</li>
                            <li>Talleres, capacitaciones sobre Visual Merchandising para microempresarios o funcionarios de una empresa.</li>
                        </ul>
                 </div>
                 <div class="col-md-6">
                      <img :src="require('@/assets/img/servicios/visual.jpg')" class="img-fluid foto-servicio" alt="">
                 </div>
             </div> -->


              <!-- <div class="row">
                  <div class="col-12">
                        <h2 class="verde-espais">Escaparatismo</h2>
                  </div>
                  <div class="col-md-6">
                         <ul>
                            <li>Diagnóstico de vidrieras o escaparates existentes</li>
                            <li>Análisis de potencialidad de los escaparates de la tienda</li>
                            <li>Diseño de los escaparates</li>
                            <li>Presupuesto de insumos para los escaparates.</li>
                            <li>Montaje y ejecución de escaparates según los diseños aprobados</li>
                            <li>Planificación semestral o anual de los cambios de escaparate en concordancia con el plan de Marketing de la marca.</li>
                            <li>Talleres, capacitaciones sobre escaparatismo para microempresarios o funcionarios de una empresa</li>
                        </ul>
                  </div>
                  <div class="col-md-6">
                      <img :src="require('@/assets/img/servicios/escaparatismo.jpg')" class="img-fluid foto-servicio" alt="">
                  </div>
              </div> -->

             <h1 class="titulo-servicios marron-espais mt-5">Clientes</h1>
             <div class="client-box pb-5">
                 <div v-for="(item,i) in slide_clientes" :key="i">
                     <img :src="`https://espais.com.py/${item.imagen.data.url}`" alt="" class="img-fluid">
                 </div>

             </div>
       </div>

</div>



</div>
</template>

<script>




export default {
    data(){
        return{
           somos:{},
           slide_clientes:[],
           servicios:[]
        }
    },
     methods: {
       loadDescripcion(){
           this.$http.get(`https://espais.com.py/admin/api/1.1/tables/somos_espais/rows/1`)
           .then(function(data){
               this.somos = data.body.data;
           })
       },
       loadService(){
         this.$http.get(`https://espais.com.py/admin/api/1.1/tables/servicios/rows`)
         .then(function(data){

           this.servicios = data.body.data;
         })
       },
       loadLogs () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/clientes/rows`)
        .then(function (data) {

        this.slide_clientes = data.body.data;


        }).then(() => {this.loading = false;})
      }
  },
    mounted () {
    this.$nextTick(function () {
      this.loadDescripcion();
      this.loadLogs();
      this.loadService();
    })
    }

}
</script>
<style>
.foto-servicio{
    max-height: 264px;
}
@media (max-width: 575.98px) {
    .foto-servicio{
     max-height: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Servicios.vue